import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import ReportHeader from './ReportHeader.jsx';
import ReportSummary from './ReportSummary.jsx';
import ReportClassification from './ReportClassification.jsx';
import ReportDiagram from './ReportDiagram.jsx';
import ReportBody from './ReportBody.jsx';
import ReportFunctional from './ReportFunctional.jsx';
import ReportWear from './ReportWear.jsx';
import ReportGuide from './ReportGuide.jsx';
import ReportRemark from './ReportRemark.jsx';
import ReportModal from './ReportModal.jsx';

import './css/Report.css';

const CalculateInstallment = (price, manufactured_year) => {
  const currentYear = new Date().getFullYear();
  const tenure = Math.min(15 - (currentYear - manufactured_year), 9);
  if(tenure < 5) {
    return (" ");
  } else {
    const installment = 0.075 * price * (1 + 0.035 * tenure) / tenure;
    return (`RM ${Math.ceil(installment).toLocaleString('en-US')} / month (${tenure} years)`)
  }
}

export default function Report() {
  const { id } = useParams();
  const [initialized, setInitialized] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const [itemData, setItemData] = useState({});
  const [screenWidth, setScreenWidth] = useState(1200);
  const [loading, setLoading] = useState(true);
  
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { manufactured_year, registered_date, manufacturer, model, cc, transmission, price, advertisement_img, mileage, inspection, inspector_remarks, accident_history } = itemData;
  const registered_year = registered_date ? registered_date.split("-")[0] : 0;
  const ccDeci = cc ? (cc/1000).toFixed(1) : 0.0;
  const title = `${manufactured_year}/${registered_year} ${manufacturer} ${model} ${ccDeci} ${transmission}`;
  const mileage_string = mileage ? mileage.toLocaleString('en-US') : "";
  const installment_string = CalculateInstallment(price, manufactured_year);
  const modelWidth = screenWidth > 400 ? 400 : "100%"

  function openGallery(index) {
    setModalIndex(index);
    setShowModal(true);
  }
  useEffect( () => {
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }
    async function initialize() {
      const response = await fetch(`/catalog-report/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setItemData(result);
      setScreenWidth(window.innerWidth);
      setInitialized(true);
    }
    initialize();
    window.addEventListener('resize', handleResize);
    handleResize();
    setLoading(false);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if(!initialized) {
    return null;
  }
  const titleSize = screenWidth > 400 ? "2em" : "1em";
  if (loading) {
    return <div style={{ height:"100vh" }}></div>; 
  }
  return (
    <div className="report-container">
      <ReportHeader id={id}/>
      <ReportSummary data={itemData} id={id} openGallery={openGallery} images={advertisement_img}/>
      <ReportClassification accidentHistory={accident_history}/>
      <ReportDiagram locations={inspection.damageIndicator}/>
      <ReportBody accidentHistory={inspection.accidentHistory}/>
      <ReportFunctional functionalIntegrity={inspection.functionalIntegrity}/>
      <ReportWear wearAndTear={inspection.wearAndTear}/>
	  { /* <ReportGuide /> */ }
      <ReportRemark remarks={inspector_remarks} />
      { showModal && (
        <ReportModal id={id} index={modalIndex} closeGallery={ () => setShowModal(false) } advertisement_img={advertisement_img} />
      )}
    </div>
  );
}
